const videoDto = video => {
	const { fields, sys } = video;
	return {
		id: sys.id,
		type: sys.contentType.sys.id,
		title: fields.title,
		subtitle: fields?.subtitle || null,
		videoUrl: fields?.videoUrl || null,
		description: fields?.description || null,
		lengthString: fields?.lengthString || null,
		thumbnail: fields.thumbnail?.fields.file.url || null,
		slug: fields?.slug || null,
		academy: fields?.academy || false,
		metaDescription: fields?.metaDescription || null,
		metaTitle: fields?.metaTitle || null,
		publishedDate: fields?.publishedDate || null,
	};
};

export default videoDto;
